import { z } from "zod";

export const LoginValidationSchema = z.object({
  username: z.string().min(4),
  password: z.string().min(6),
});

export type LoginRequest = z.infer<typeof LoginValidationSchema>;
